// NOTE 
// Este componente va a mostrar informacion detallada del servicio de Regencia Química

// React 
import  React  from 'react'

// Routing
import { withRouter } from 'react-router-dom'

const RegenciaQuimicaInfo = () => {
  return (
    <div>
      Regencia Quimica Info
    </div>
  )
}

export default withRouter(RegenciaQuimicaInfo)


// WEBPACK FOOTER //
// ./src/paginas/RegenciaQuimicaInfo.js